import { isNil } from "lodash";
import { roundFte } from "src/util/roundingStrategy";
import { getForecastReadonlyFlag } from "src/allocation/util/allocationProject";
import { calculateTotalCost } from "src/allocation/util/budgetAndCost";

import newCell from "../newCell";
import {
  newForecastNotification,
  newNotification,
} from "../../newNotification";

const getFteValue = ({ isActive, requestSubmitted, forecast }) => {
  if (isActive) {
    return requestSubmitted;
  }
  return forecast;
};

export default ({
  lineItem,
  column,
  macroAllocation,
  allocationProject,
  rootGroup,
  enableDemandRequest = false,
}) => {
  const {
    id,
    allocationProjectId,
    targetGroupId,
    sourceGroupId,
    requestSubmittedAt,
    requestSubmitted,
    forecast,
    forecastedAt,
    allocatedMemberFte,
  } = macroAllocation;

  const { isStatic } = column;
  const { isActive, enableRequirementInput, workingDays } = allocationProject;
  const { dailyRate, grouping } = lineItem;
  const { isMovedOut } = grouping;
  const isReadonly = getForecastReadonlyFlag(allocationProject, rootGroup);
  let value;
  let notification;
  let totalCost;

  if (isMovedOut) {
    value = 0;
    totalCost = null;
    notification = newNotification({
      status: null,
      message: null,
      groupMessage: null,
      columnMessage: null,
    });
  } else {
    const fte = getFteValue({
      isActive,
      requestSubmitted,
      forecast,
    });

    value = isNil(fte) ? null : roundFte(fte);
    notification = newForecastNotification(
      macroAllocation,
      rootGroup,
      isActive
    );
    totalCost = isActive
      ? null
      : calculateTotalCost({
          value,
          dailyRate,
          workingDays,
        });
  }

  return newCell({
    lineItem,
    column,
    columnType: column.columnType,
    id,
    macroAllocationId: id,
    targetGroupId,
    sourceGroupId,
    allocationProjectId,
    isStatic,
    isEditable: !enableDemandRequest && !isStatic && !isActive && !isReadonly,
    value,
    skills: macroAllocation.note,
    notification,
    isRequirementInputEnabled: enableRequirementInput,
    totalCost,
    workingDays,
    dailyRate,
    forecastedAt,
    requestSubmittedAt,
    currentFteSum:
      enableDemandRequest && !isNil(allocatedMemberFte)
        ? roundFte(allocatedMemberFte)
        : null,
  });
};
